module.exports = __webpack_public_path__ + "static/media/bitcoin1.23efe1b0.png";